module.exports = __webpack_public_path__ + "img/checkbox.2655c5da.svg";